"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("lodash");
var autoBind = require("auto-bind");
var colorsys = require("colorsys");
var TemplateManifest_1 = require("../broadcast/template/TemplateManifest");
var ImageAsset_1 = require("../broadcast/template/animation/assets/ImageAsset");
var Media_1 = require("../data/Media");
var Item_1 = require("../data/Item");
var EffectValue_1 = require("./template/animation/effects/EffectValue");
var AnimationFont_1 = require("./template/animation/fonts/AnimationFont");
var AssetFactory_1 = require("./template/animation/assets/AssetFactory");
var Common_1 = require("../data/Common");
var EnvironmentUtils_1 = require("../../EnvironmentUtils");
var MediaVersionSelectionStrategyImpl = (function () {
    function MediaVersionSelectionStrategyImpl(maxResolution) {
        if (maxResolution === void 0) { maxResolution = undefined; }
        autoBind(this);
        this.maxResolution = maxResolution;
    }
    MediaVersionSelectionStrategyImpl.prototype.findMediaVersion = function (media, width, height) {
        if (media === undefined || media.versions === undefined || media.versions.length < 1) {
            return undefined;
        }
        var versions = media.versions;
        var componentAR = width / height;
        var mediaAR = media.width / media.height;
        var targetResolution = null;
        if (componentAR < mediaAR) {
            targetResolution = this.maxResolution === undefined || width < this.maxResolution ? width : targetResolution;
        }
        else {
            targetResolution = this.maxResolution === undefined || height < this.maxResolution ? height : targetResolution;
        }
        var selected = versions[0];
        for (var i = 1; i < versions.length; i++) {
            var candidate = versions[i];
            if (componentAR < mediaAR) {
                if (candidate.width >= targetResolution && candidate.width < selected.width) {
                    selected = candidate;
                }
            }
            else {
                if (candidate.height >= targetResolution && candidate.height < selected.height) {
                    selected = candidate;
                }
            }
        }
        return { media: media, version: selected };
    };
    return MediaVersionSelectionStrategyImpl;
}());
exports.MAX_QUALITY_MEDIA_VERSION_SELECTION_STRATEGY = new MediaVersionSelectionStrategyImpl();
exports.DIGITAL_WINDOW_MEDIA_VERSION_SELECTION_STRATEGY = new MediaVersionSelectionStrategyImpl(1920);
exports.MAX_PERFORMANCE_MEDIA_VERSION_SELECTION_STRATEGY = new MediaVersionSelectionStrategyImpl(640);
var NO_MEDIA_SIZES = [60, 120, 240, 480, 960, 1080, 1920];
var NO_MEDIA_VERSIONS = {
    mimeType: "image/jpeg",
    path: "static/img/",
    state: Media_1.MediaState.READY,
    lcs: Common_1.LifeCycleState.Active,
    versions: NO_MEDIA_SIZES.map(function (size) {
        var path = "filkers-no-media-" + size + ".jpg";
        return { name: "" + size, width: size, height: size, path: path, poster: path };
    })
};
var EMPTY_MEDIA = {
    mimeType: "image/jpeg",
    path: "static/img/",
    state: Media_1.MediaState.READY,
    lcs: Common_1.LifeCycleState.Active,
    versions: [
        { width: 1, height: 1, path: "empty.png" }
    ]
};
var FIND_CR_REGEXP = new RegExp('\n', 'g');
var FIND_TRAILING_CRS_REGEXP = new RegExp('\n+$', 'g');
var BroadcastUtilsImpl = (function () {
    function BroadcastUtilsImpl() {
        this.modificationCounter = 0;
        this.defaultMediaVersionSelectionStrategy = exports.MAX_QUALITY_MEDIA_VERSION_SELECTION_STRATEGY;
        autoBind(this);
    }
    BroadcastUtilsImpl.prototype.getMediaVersionSelectionStrategy = function () {
        return this.defaultMediaVersionSelectionStrategy;
    };
    BroadcastUtilsImpl.prototype.setMediaVersionSelectionStrategy = function (selectionStrategy) {
        this.defaultMediaVersionSelectionStrategy = selectionStrategy;
    };
    BroadcastUtilsImpl.prototype.findLocalizedItemData = function (item) {
        var data = item.data['es_ES'];
        if (data === undefined) {
            data = Object.values(item.data)[0];
        }
        return data;
    };
    BroadcastUtilsImpl.prototype.mergeConfigData = function (template, config) {
        if (config === void 0) { config = {}; }
        var result = {};
        if (template !== undefined) {
            var templateConfigClone_1 = _.cloneDeep(template.config);
            template.manifest.g
                .flatMap(function (g) { return g.p; })
                .forEach(function (p) {
                var dataToCombineWith = config[p.id] === undefined ? {} : config[p.id];
                var combinedConfig = _.merge(templateConfigClone_1[p.id], dataToCombineWith);
                if ((p.t === TemplateManifest_1.TemplatePropertyType.Media || p.t === TemplateManifest_1.TemplatePropertyType.Logo) && dataToCombineWith.m !== undefined) {
                    var combinedMediaData = combinedConfig;
                    combinedMediaData.m = dataToCombineWith.m;
                }
                result[p.id] = combinedConfig;
            });
        }
        return result;
    };
    BroadcastUtilsImpl.prototype.modifyAnimationWithData = function (animation, template, configData, item, containerWidth, containerHeight) {
        var _this = this;
        if (containerWidth === void 0) { containerWidth = undefined; }
        if (containerHeight === void 0) { containerHeight = undefined; }
        if (template !== undefined) {
            var masterScale_1 = 1.0;
            if (containerWidth !== undefined && containerHeight !== undefined) {
                var containerAR = containerWidth / containerHeight;
                if (containerAR < template.aspectRatio) {
                    masterScale_1 = containerWidth / template.width;
                }
                else {
                    masterScale_1 = containerHeight / template.height;
                }
            }
            var mergedConfigData_1 = this.mergeConfigData(template, configData);
            var manifest_1 = template.manifest;
            var dedupKey_1 = this.modificationCounter++;
            template.manifest.g.forEach(function (group) {
                group.p.forEach(function (property) {
                    _this.applyPropertyData(dedupKey_1, animation, manifest_1, property, mergedConfigData_1, item, masterScale_1);
                });
            });
        }
    };
    BroadcastUtilsImpl.prototype.extractLinkedPropertyData = function (property, item) {
        if (property.link === undefined || item === undefined) {
            return undefined;
        }
        else if (property.t === TemplateManifest_1.TemplatePropertyType.Media) {
            var lastDotIndex = property.link.lastIndexOf(".");
            if (lastDotIndex < 0) {
                return null;
            }
            var path = property.link.substring(0, lastDotIndex);
            var index = parseInt(property.link.substring(lastDotIndex + 1, property.link.length));
            var media = _.get(item, path);
            if (media === undefined || !_.isArray(media) || media.length < 1) {
                return null;
            }
            return media[index % media.length];
        }
        else {
            switch (item.type) {
                case Item_1.ItemType.PRODUCT:
                    var itemData = this.findLocalizedItemData(item);
                    if (itemData === undefined) {
                        return null;
                    }
                    else {
                        var linkedData_1 = _.get(itemData, property.link);
                        return linkedData_1 === undefined ? null : linkedData_1;
                    }
                default:
                    var linkedData = _.get(item, property.link);
                    return linkedData === undefined ? null : linkedData;
            }
        }
    };
    BroadcastUtilsImpl.prototype.applyPropertyData = function (dedupKey, animation, manifest, property, configData, item, masterScale) {
        var layerHolder = property.c === null ? animation : animation.getAssetsMap().findById(property.c);
        var compRef = manifest.refs[property.c];
        var propertyData = configData === undefined ? undefined : configData[property.id];
        try {
            var layers = property.ix.map(function (index) { return layerHolder.findLayerByIndex(index); });
            switch (property.t) {
                case TemplateManifest_1.TemplatePropertyType.Checkbox:
                    this.applyCheckboxPropertyData(layers[0], property, propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Color:
                    this.applyColorPropertyData(layers[0], property, propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.DropDown:
                    this.applyDropDownPropertyData(layers[0], property, propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Media:
                    this.applyMediaPropertyData(animation, compRef, layers, property, propertyData, item, masterScale);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Logo:
                    this.applyMediaPropertyData(animation, compRef, layers, property, tslib_1.__assign(tslib_1.__assign({}, propertyData), { ss: TemplateManifest_1.ImageScaleStrategy.FIT }), item, masterScale);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Palette:
                    this.applyPalettePropertyData(layers[0], propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Number:
                    this.applyNumberPropertyData(layers[0], property, propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Slider:
                    this.applySliderPropertyData(layers[0], property, propertyData);
                    break;
                case TemplateManifest_1.TemplatePropertyType.Text:
                    this.applyTextPropertyData(dedupKey, animation, layers, property, propertyData, item);
                    break;
                default:
                    console.error("I don't know how to handle properties of type " + property.t);
            }
        }
        catch (err) {
            console.error("Error while trying to replace " + property.c + " ->  " + JSON.stringify(property.ix) + " with " + JSON.stringify(propertyData) + " : " + err);
        }
    };
    BroadcastUtilsImpl.prototype.applyTextPropertyData = function (dedupKey, animation, textLayers, property, data, item) {
        if (item === void 0) { item = undefined; }
        var linkedData = this.extractLinkedPropertyData(property, item);
        var text = "";
        if (linkedData === undefined) {
            text = data.t;
        }
        else if (linkedData === null) {
            text = "";
        }
        else {
            text = linkedData;
        }
        text = text.replace(FIND_TRAILING_CRS_REGEXP, '').replace(FIND_CR_REGEXP, '\r');
        var font = new AnimationFont_1.AnimationFont({}, animation.version);
        font = Object.assign(font, data.f);
        font.name = "fnt-" + property.id;
        font.family = "lot-" + dedupKey + "-" + data.f.uid;
        font.weight = "";
        animation.getFontsMap().push(font);
        textLayers.forEach(function (textLayer) {
            var kfv = textLayer.findFirstKeyFrame().start;
            if (property.ml === true) {
                kfv.fontSize = data.fs;
                kfv.lineHeight = data.lh;
                kfv.textJustify = data.j;
            }
            kfv.fontName = font.name;
            kfv.text = text;
        });
    };
    BroadcastUtilsImpl.prototype.applyMediaPropertyData = function (animation, compRef, layers, property, data, item, masterScale) {
        if (item === void 0) { item = undefined; }
        var mediaData = undefined;
        var defaultScalingStrategy = property.ss === undefined ? TemplateManifest_1.ImageScaleStrategy.FIT : property.ss;
        var linkedData = this.extractLinkedPropertyData(property, item);
        if (linkedData === undefined) {
            mediaData = data;
        }
        else if (linkedData === null) {
            console.log("Missing link data");
            layers.forEach(function (l) { return l.hidden = true; });
            return;
        }
        else {
            var a = data.a, m = data.m, mediaInheritedProps = tslib_1.__rest(data, ["a", "m"]);
            mediaData = tslib_1.__assign(tslib_1.__assign({}, mediaInheritedProps), { m: linkedData });
        }
        if (mediaData === undefined) {
            mediaData = { ss: defaultScalingStrategy, m: EMPTY_MEDIA };
        }
        if (mediaData.m === undefined && mediaData.a === undefined) {
            mediaData.m = EMPTY_MEDIA;
        }
        if (mediaData.ss === undefined) {
            mediaData.ss = defaultScalingStrategy;
        }
        var boxSizeInAnim = { w: compRef.w * compRef.s, h: compRef.h * compRef.s };
        var boxAR = compRef.w * 1.0 / compRef.h;
        var mediaAR = (mediaData.m === undefined ? mediaData.a.width * 1.0 / mediaData.a.height : mediaData.m.width * 1.0 / mediaData.m.height);
        var mediaSizeInAnimation = null;
        if ((boxAR < mediaAR && mediaData.ss == TemplateManifest_1.ImageScaleStrategy.FIT) || (boxAR > mediaAR && mediaData.ss == TemplateManifest_1.ImageScaleStrategy.FILL)) {
            mediaSizeInAnimation = { w: boxSizeInAnim.w, h: boxSizeInAnim.w / mediaAR };
        }
        else {
            mediaSizeInAnimation = { w: boxSizeInAnim.h * mediaAR, h: boxSizeInAnim.h };
        }
        var asset = new ImageAsset_1.ImageAsset({}, animation.version);
        asset.id = "ovx-" + property.id;
        if (mediaData.m !== undefined) {
            var realMediaSize = {
                w: Math.ceil(mediaSizeInAnimation.w * masterScale),
                h: Math.ceil(mediaSizeInAnimation.h * masterScale)
            };
            var msr = this.getMediaVersionSelectionStrategy().findMediaVersion(mediaData.m, realMediaSize.w, realMediaSize.h);
            asset.width = msr.version.width;
            asset.height = msr.version.height;
            asset.path = "" + EnvironmentUtils_1.EnvironmentUtils.getMediaBaseUrl(msr.media);
            asset.image = msr.version.path;
            asset.embedded = false;
        }
        else if (mediaData.a !== undefined) {
            var assetId = asset.id;
            asset = AssetFactory_1.AssetFactory.clone(mediaData.a);
            asset.id = assetId;
        }
        animation.getAssetsMap().push(asset);
        var scale = null;
        switch (mediaData.ss) {
            case TemplateManifest_1.ImageScaleStrategy.FIT:
                scale = ((boxAR > mediaAR) ? compRef.h * 1.0 / asset.height : compRef.w * 1.0 / asset.width) * 100;
                break;
            case TemplateManifest_1.ImageScaleStrategy.FILL:
                scale = ((boxAR > mediaAR) ? compRef.w * 1.0 / asset.width : compRef.h * 1.0 / asset.height) * 100;
                break;
        }
        layers.forEach(function (imageLayer) {
            imageLayer.imageId = asset.id;
            var layerScale = imageLayer.transform.scale.value;
            layerScale[0] = scale;
            layerScale[1] = scale;
            var position = imageLayer.transform.position;
            position[0] = 0;
            position[1] = 0;
            var anchorPoint = imageLayer.transform.anchorPoint.value;
            anchorPoint[0] = Math.abs(asset.width / 2);
            anchorPoint[1] = Math.abs(asset.height / 2);
        });
    };
    BroadcastUtilsImpl.prototype.applySliderPropertyData = function (layer, property, data) {
        var effect = layer.effects[property.ef - 1];
        if (effect.effectValues.length > 0) {
            var effectValue = effect.effectValues[0];
            effectValue.value.value = data.v;
        }
    };
    BroadcastUtilsImpl.prototype.applyNumberPropertyData = function (layer, property, data) {
        var effect = layer.effects[property.ef - 1];
        if (effect.effectValues.length > 0) {
            var effectValue = effect.effectValues[0];
            effectValue.value.value = data.v;
        }
    };
    BroadcastUtilsImpl.prototype.applyCheckboxPropertyData = function (layer, property, data) {
        var effect = layer.effects[property.ef - 1];
        if (effect.effectValues.length > 0) {
            var effectValue = effect.effectValues[0];
            effectValue.value.value = data.v === true ? 1 : 0;
        }
    };
    BroadcastUtilsImpl.prototype.applyDropDownPropertyData = function (layer, property, data) {
        var effect = layer.effects[property.ef - 1];
        if (effect.effectValues.length > 0) {
            var effectValue = effect.effectValues[0];
            effectValue.value.value = data.v + 1;
        }
    };
    BroadcastUtilsImpl.prototype.applyColorPropertyData = function (layer, property, data) {
        if (data !== undefined) {
            var effect = layer.effects[property.ef - 1];
            if (effect.effectValues.length > 0) {
                var effectValue = effect.effectValues[0];
                this.applyHSLColorToEffectValue(effectValue, data.c);
            }
        }
    };
    BroadcastUtilsImpl.prototype.applyPalettePropertyData = function (layer, data) {
        var _this = this;
        if (data !== undefined) {
            var palette_1 = data.p;
            if (palette_1 !== undefined) {
                layer.effects.forEach(function (ef) {
                    if (ef.effectValues.length > 0) {
                        var effectValue = ef.effectValues[0];
                        if (effectValue.type === EffectValue_1.EffectValueType.Color) {
                            var hsl = null;
                            switch (ef.name) {
                                case "lightShade":
                                    hsl = palette_1.ls;
                                    break;
                                case "lightAccent":
                                    hsl = palette_1.la;
                                    break;
                                case "mainColor":
                                    hsl = palette_1.m;
                                    break;
                                case "darkAccent":
                                    hsl = palette_1.da;
                                    break;
                                case "darkShade":
                                    hsl = palette_1.ds;
                                    break;
                            }
                            if (hsl !== null) {
                                _this.applyHSLColorToEffectValue(effectValue, hsl);
                            }
                        }
                    }
                });
            }
        }
    };
    BroadcastUtilsImpl.prototype.applyHSLColorToEffectValue = function (effectValue, hsl) {
        var rgb = colorsys.hsl_to_rgb(hsl);
        var normalizedRGBA = effectValue.value.value;
        normalizedRGBA[0] = rgb.r / 255.0;
        normalizedRGBA[1] = rgb.g / 255.0;
        normalizedRGBA[2] = rgb.b / 255.0;
    };
    return BroadcastUtilsImpl;
}());
exports.BroadcastUtils = new BroadcastUtilsImpl();
//# sourceMappingURL=BroadcastUtils.js.map